export default __webpack_public_path__ + "static/media/Ot.1937d7ef.svg";